export const it = {
  // Common
  common: {
    login: "Accedi",
    logout: "Esci",
    register: "Registrati",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    back: "Indietro",
    next: "Avanti",
    submit: "Invia",
    confirm: "Conferma",
    close: "Chiudi",
    search: "Cerca",
    loading: "Caricamento...",
    open: "Apri",
    download: "Scarica",
    upload: "Carica",
    view: "Vedi",
    yes: "Sì",
    no: "No",
    status: "Stato",
    created: "Creato",
    updated: "Aggiornato",
    actions: "Azioni",
    profile: "Profilo",
    settings: "Impostazioni",
    notifications: "Notifiche",
    messages: "Messaggi",
    documents: "Documenti",
    home: "Home pubblica",
    dashboard: "Dashboard",
    none: "Nessuno",
    all: "Tutti",
  },

  // Nav
  nav: {
    how_it_works: "Come funziona",
    solutions: "Soluzioni",
    why_cxoora: "Perché CXOORA",
    for_companies: "Per le imprese",
    for_managers: "Per i manager",
    faq: "FAQ",
    free_checkup: "Fai il check-up gratuito",
    go_to_dashboard: "Vai alla dashboard",
    apply_to_network: "Candidati al network",
  },

  // Hero
  hero: {
    badge: "Leadership as a Service",
    title_main: "Il manager che ti serve.",
    title_accent: "Solo per il tempo che serve.",
    subtitle: "CXOORA aiuta PMI e aziende in crescita ad accedere a manager esperti senza dover assumere un dirigente a tempo pieno. Individuiamo il professionista più adatto, definiamo gli obiettivi e misuriamo i risultati.",
    cta_primary: "Scopri di quale manager hai bisogno",
    cta_secondary: "Parla con un nostro esperto",
    cta_note: "Il primo check-up è gratuito e richiede pochi minuti.",
    flexibility: "Una competenza senior può entrare nella tua azienda per alcuni giorni al mese, uno o due giorni alla settimana oppure per un progetto specifico.",
    journey: "Il percorso CXOORA",
    journey_steps: {
      need: { label: "Analisi del bisogno", value: "Check-up gratuito" },
      selection: { label: "Selezione del manager", value: "Shortlist max 3" },
      project: { label: "Progetto attivato", value: "Milestone & timeline" },
      kpi: { label: "KPI monitorati", value: "In tempo reale" },
      results: { label: "Risultati", value: "Misurabili" },
    },
    apply: "Candidati al network",
  },

  // Sections
  sections: {
    problem_badge: "Il problema",
    problem_title: "La tua azienda sta crescendo, ma non puoi gestire tutto da solo.",
    solution_badge: "La soluzione",
    solution_title: "Una competenza da grande azienda, accessibile anche alla tua PMI.",
    before_after_title: "Da un problema difficile da gestire a un percorso chiaro.",
    before: "Prima",
    with_cxoora: "Con CXOORA",
    how_works_badge: "Come funziona",
    how_works_title: "Un percorso semplice. Un supporto concreto.",
    benefits_badge: "Perché CXOORA",
    benefits_title: "Una soluzione concreta per aziende che vogliono fare un salto di qualità.",
    audience_title: "CXOORA è pensata per la tua azienda se…",
    comparison_title: "Perché scegliere una formula fractional?",
    final_cta_title_main: "Non sempre serve assumere un nuovo dirigente.",
    final_cta_title_accent: "Serve trovare quello giusto.",
    final_cta_subtitle: "Completa il check-up gratuito. Ti aiuteremo a capire quale competenza manageriale può generare maggiore valore nella tua azienda.",
  },

  // Footer
  footer: {
    tagline: "La leadership giusta, quando serve.",
    description: "Piattaforma di Fractional Management per PMI italiane.",
    service: "Servizio",
    resources: "Risorse",
    legal: "Legali",
    privacy: "Privacy Policy",
    cookie: "Cookie Policy",
    terms: "Termini e condizioni",
    ethics: "Codice etico",
    rights: "Tutti i diritti riservati. Demo MVP.",
  },

  // Auth
  auth: {
    welcome_back: "Bentornato",
    welcome_subtitle: "Accedi alla tua area riservata.",
    email: "Email",
    password: "Password",
    no_account: "Non hai un account?",
    have_account: "Hai già un account?",
    demo_accounts: "Account demo (Demo2025!)",
    admin_label: "Admin",
    company_label: "Azienda",
    manager_label: "Manager",
    create_account: "Crea un account",
    register_subtitle: "Scegli la tipologia di registrazione e completa i dati.",
    company_name: "Ragione sociale",
    full_name: "Nome completo",
    phone_optional: "Telefono (opzionale)",
    password_hint: "Password (min 6 caratteri)",
    terms_consent: "Registrandoti accetti i nostri",
    and: "e la",
    forgot_password: "Password dimenticata?",
  },

  // Dashboard
  dashboard: {
    overview: "Panoramica",
    company_profile: "Profilo aziendale",
    checkup: "Check-up",
    requests: "Richieste",
    shortlist: "Shortlist",
    meetings: "Incontri",
    proposals: "Proposte",
    projects: "Progetti",
    invoices: "Fatture",
    availability: "Disponibilità",
    opportunities: "Opportunità",
    referrals: "Referral",
    companies: "Aziende",
    managers: "Manager",
    applications: "Candidature",
    matching: "Matching & Shortlist",
    calls: "Call",
    packages: "Pacchetti",
    analytics: "Analytics",
    audit_log: "Audit log",
    welcome_user: "Benvenuto, {{name}}",
    activity_overview: "Ecco una panoramica della tua attività.",
    suggested_actions: "Azioni consigliate",
    recent_notifications: "Notifiche recenti",
    recent_requests: "Le tue richieste recenti",
    no_notifications: "Nessuna notifica",
    see_all: "Vedi tutte",
  },

  // Shortlist
  shortlist: {
    title: "Le tue shortlist",
    subtitle: "Esplora i manager selezionati per te. Confronta fino a 3 profili.",
    match_score: "Match score",
    request_call: "Richiedi call",
    profile_btn: "Profilo",
    compare: "Confronto manager",
    no_shortlist: "Non hai ancora una shortlist disponibile. Il team CXOORA sta lavorando alla tua selezione.",
    download_pdf: "Scarica PDF",
  },

  // Project workspace
  project: {
    timeline: "Timeline",
    milestones: "Milestone",
    kpi: "KPI",
    tasks: "Task",
    time_entries: "Ore/Giornate",
    feedback: "Feedback",
    progress: "Avanzamento",
    company: "Azienda",
    manager: "Manager",
    package: "Pacchetto",
    duration: "Durata",
    objective: "Obiettivo",
    scope: "Scope",
    download_report: "Scarica report PDF",
  },

  // Settings
  settings: {
    account: "Account",
    change_password: "Cambia password",
    current_password: "Password attuale",
    new_password: "Nuova password",
    update_password: "Aggiorna password",
    language: "Lingua",
    google_connect: "Connetti Google Calendar",
    google_connected: "Connesso come",
    google_disconnect: "Disconnetti",
    google_not_configured: "Integrazione Google non ancora configurata dall'amministratore",
  },

  // Referrals
  referrals: {
    title: "I tuoi referral",
    subtitle: "Invita altri manager senior nel network CXOORA. Riceverai un riconoscimento quando il referral viene approvato.",
    invite_new: "Invita un manager",
    referee_name: "Nome candidato",
    referee_email: "Email candidato",
    referee_role: "Ruolo target (opzionale)",
    note: "Note (opzionale)",
    send_invite: "Genera invito",
    invite_link: "Link invito",
    copy_link: "Copia link",
    link_copied: "Link copiato",
    no_referrals: "Non hai ancora inviato referral.",
    status_pending: "In attesa",
    status_invited: "Invitato",
    status_submitted: "Candidatura inviata",
    status_approved: "Approvato",
    status_rejected: "Rifiutato",
  },
};
